import React from 'react';
import './FeaturesSection.css';

interface Feature {
  id: string;
  icon: string;
  title: string;
  description: string;
}

const FeaturesSection: React.FC = () => {
  const features: Feature[] = [
    {
      id: '1',
      icon: 'fas fa-palette',
      title: 'Thiết kế độc đáo',
      description: 'Mỗi sản phẩm được thiết kế tỉ mỉ với phong cách riêng biệt, mang đến vẻ đẹp sang trọng và hiện đại cho đôi tay của bạn.'
    },
    {
      id: '2',
      icon: 'fas fa-undo',
      title: 'Đổi trả miễn phí',
      description: 'Chúng tôi cam kết đổi trả miễn phí trong vòng 30 ngày nếu sản phẩm không đúng như mô tả hoặc có lỗi.'
    },
    {
      id: '3',
      icon: 'fas fa-code',
      title: 'Chất lượng cao',
      description: 'Sản phẩm được làm từ chất liệu cao cấp, an toàn cho sức khỏe và dễ dàng sử dụng, mang đến trải nghiệm tuyệt vời.'
    },
  ];

  return (
    <section className="features-section">
      <div className="container">
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-item">
              <i className={feature.icon}></i>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;

